module.exports = __webpack_public_path__ + "public/media/sheikh.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/sheikh.png
// module id = ./images/partners/sheikh.png
// module chunks = 0